<!-- =========================================================================================
    File Name: UploadDefault.vue
    Description: Rendering of default Upload
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <vx-card title="Contrato Social">
        
        <p>Para solicitar seu crédito, é necessário cadastrar o contrato social em PDF:</p>

        <vs-alert v-if="not_document" color="primary" icon="new_releases" active="true" class="mt-1">
            Adicione o documento no campo abaixo
        </vs-alert>
        <vs-alert v-if="has_document" color="danger" icon="new_releases" active="true" class="mt-1">
            <p>Você já cadastrou {{number_documents}} documento(s). O máximo é 3 para cada tipo de arquivo solicitado. Você receberá um email quando aprovado o documento.</p>
        </vs-alert>

        <div class="mt-1" v-if="block">
            <vs-upload :limit="limit" :action="url_contrato" :disabled="disabled" @on-success="successUpload" @on-error="errorUpload" />
        </div>


    </vx-card>


</template>

<script>
export default {
    data() {
        return {
            url_contrato: this.$store.state.API_URL+'documentos/upload/contrato/'+localStorage.getItem("token"),
            disabled: true,
            not_document: true,
            has_document: false,
            number_documents: 0,
            block: true,
            limit: 3
        }
    },
    created() {
        const thisIns = this;
        fetch(this.$store.state.API_URL + 'Info/Home', {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
            body: "token="+localStorage.getItem("token")
        })
        .then((response) => response.text())
        .then((responseData) => {

            var dados = JSON.parse(responseData);
            if(dados.meus_dados.documentos_1 > 0)
            {
                this.not_document = false;
                this.has_document = true;
                this.number_documents = dados.meus_dados.documentos_1;
                this.limit -= dados.meus_dados.documentos_1;
            }
            if(dados.meus_dados.documentos_1 >= 3)
            {
                this.block = false;

            }

        });
    },
    methods: {
        successUpload(retorn) {
            console.log(retorn.target.response);
            var dados = JSON.parse(retorn.target.response);
            this.$vs.notify({ color: 'success', title: 'Status', text: dados.message })
        },
        errorUpload(retorn) {
            console.log(retorn.target.response);
            var dados = JSON.parse(retorn.target.response);
            this.$vs.notify({ color: 'danger', title: 'Status', text: dados.message })
        }
    }
}
</script>